if (!customElements.get("faq-search")) {
  customElements.define(
    "faq-search",
    class FaqSearch extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.resultList = this.querySelector(".result-box__list");
        this.emptyNote = this.querySelector(".result-box__empty");
        this.form = this.querySelector("form");
        this.clear = this.querySelector(".result-box__clear");
        this.results = new Proxy([], {
          get: (target, key) => {
            console.log("get results", target, key);
            return Reflect.get(target, key);
          },
          set: (target, key, value, receiver) => {
            console.log("set results", target, key, value);

            if (value.title && value.answer) {
              Reflect.set(target, key, value, receiver);
              this.render();
            } else if (key == "length") {
              if (value === 0) {
                this.emptyNote.classList.remove("hidden");
              } else {
                this.emptyNote.classList.add("hidden");
              }
              // if(target.length === 0) {
              //   this.emptyNote.classList.remove("hidden");
              // }else{
              //   this.emptyNote.classList.add("hidden");
              // }
              Reflect.set(target, key, value, receiver);
              this.render();
            }
            return true;
          },

          // deleteProperty: (target, key) => {
          //   console.log("arrProxy.deleteProperty", target, key);
          //   Reflect.deleteProperty(target, key);

          //   this.render();
          //   return true;
          // },
        });
        this.searchButton = this.querySelector("#SearchQuestion");
        this.input = this.querySelector("input");
        this.form.addEventListener("submit", this.handleSearch.bind(this));
        this.clear.addEventListener("click", this.clearSearch.bind(this));
        this.faqs = document.querySelectorAll(".all-faqs .faq-item");
        this.render();
      }
      handleSearch(e) {
        e.preventDefault();
        this.classList.add("in-search");
        const searchString = this.input.value;
        // this.results = [];
        this.results.splice(0, this.results.length);
        console.log(this.results, this.faqs);
        document
          .querySelectorAll(".all-faqs .faq-item")
          .forEach((faq, index) => {
            const title = faq.querySelector(".question-title").dataset.text;
            const answer = faq.querySelector(".question-answer").dataset.text;
            // console.log(title, answer);
            const isMatch =
              title.toLowerCase().includes(searchString.toLowerCase()) ||
              answer.toLowerCase().includes(searchString.toLowerCase());
            if (isMatch) {
              const answerHtml =
                faq.querySelector(".question-answer").dataset.html;
              this.results.push({
                title,
                answer: answerHtml,
              });
            }
          });
      }
      clearSearch() {
        this.results.splice(0, this.results.length);
        this.classList.remove("in-search");
        this.input.value = "";
      }
      render() {
        this.resultList.innerHTML = ``;
        this.results.forEach((result, index) => {
          if (result.title && result.answer) {
            const element = document.createElement("div");
            element.classList.add("faq-item");
            element.innerHTML = `
              <animation-details>
                <details>
                  <summary>
                    <span>
                      ${result?.title}
                    </span>
                    <span class="indicator">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-detail-collapsed">
                        <path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-detail-expanded">
                        <path d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </summary>
                  <div class="accordion__content rte">${result.answer}</div>
                </details>
              </animation-details>  
            `;
            this.resultList.appendChild(element);
          }
        });
      }
    }
  );
}
